import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import PanelContentWrapper from '../../components/PanelContentWrapper';
import { AcceptanceForm } from './AcceptanceForm';
import { apiUrl } from '../../api';
import { Permission } from '../../hooks/Permission';

export const AcceptanceCreate = () => {
    const token = useSelector((store) => store.token);
    const [redirect, setRedirect] = useState(null);

    return (
        <>
            <Permission permission="acceptance-store" />
            {redirect && <Redirect to={redirect} />}

            <PanelContentWrapper>
                <AcceptanceForm
                    onSubmit={(values) => {
                        axios
                            .post(`${apiUrl}/acceptance`, values, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            })
                            .then(
                                ({
                                    data: {
                                        acceptance: { id },
                                    },
                                }) => {
                                    setRedirect(`/zgody/${id}`);
                                    NotificationManager.success('Dodano zgodę');
                                },
                            )
                            .catch(() => {
                                NotificationManager.error('spróbuj ponownie', 'Błąd ');
                            });
                    }}
                    initialValues={{ obligatory: '1' }}
                />
            </PanelContentWrapper>
        </>
    );
};
